import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { ArchivosCreditosService } from "../../../services/archivos-creditos.service";
import { HelpersService } from '../../../services/tools/helpers.service';
declare var $;

@Component({
  selector: 'adjuntar-archivos',
  templateUrl: './adjuntar-archivos.component.html'
})
export class AdjuntarArchivosComponent implements OnInit {
    /**
   * Tipos de archivos
   */
  public static readonly ARCHIVO_CLIENTE : number = 1;
  public static readonly ARCHIVO_CAPACIDAD_PAGO : number = 2;
  public static readonly ARCHIVO_AVALUO : number = 3;
  public static readonly ARCHIVO_AVAL : number = 4;
  public static readonly ARCHIVO_UNIDAD : number = 5;
  public static readonly ARCHIVO_GASCOM : number = 6;
  public static readonly ARCHIVO_CENTRO_CONSUMO : number = 7;
  public static readonly ARCHIVO_SUBPRODUCTO : number = 9;

  @Input() public idCreditos: number = null;
  @Input() public isEditable: boolean = false;
  @Input() public tipoArchivos: string = null;
  @Output() public onClientUpdated:EventEmitter<string> = new EventEmitter;
  //Cliente form
  public listArchivos: any = [];
  public uploadingFile : boolean = false;
  public errors:any = {};
  public idTipoArchivos : number = 0;

  constructor(
    private archivosService: ArchivosCreditosService,
    private helperService: HelpersService
  ){
  }

  ngOnInit() {
      switch(this.tipoArchivos){
          case 'cliente':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_CLIENTE;
            break;
          case 'capacidad-pago':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_CAPACIDAD_PAGO;
            break;
          case 'avaluo':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_AVALUO;
            break;
          case 'aval':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_AVAL;
            break;
          case 'unidad':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_UNIDAD;
            break;
          case 'gascom':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_GASCOM;
            break;
          case 'centro-consumo':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_CENTRO_CONSUMO;
            break;
          case 'subproducto':
            this.idTipoArchivos = AdjuntarArchivosComponent.ARCHIVO_SUBPRODUCTO;
            break;
      }  
  }

  public reloadListaArchivos(){
      this.getArchivos(this.idCreditos);    
  }

  private getArchivos(idCreditos : number){
    //TODO: Manejar cuando el id no retorna un crédito valido
    
    this.archivosService.get(idCreditos, this.idTipoArchivos).subscribe(
      (response)=>
      {
        const archivos = response.json().content;
        this.listArchivos = archivos;
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  /**
   * Upload files
   */
  public uploadFile(event) {
      //Show spinner
      this.uploadingFile = true;

      let fileInfo = 
      {
          idCreditos : this.idCreditos,
          tipo: this.idTipoArchivos,
          descripcion: ''
      };

      let observableResponse = this.archivosService.save(event, fileInfo);

      if(!observableResponse){
        //Si al hacer el Upload del archivo se cancela la carga, cae en este escenario 
        this.uploadingFile = false;
        return;
      }

      observableResponse.subscribe(
          (response)=>
          {
              let archivo = response.json().content;
              //Se agrega la info del nuevo archivo a la lista para que se muestre en el formulario
              this.listArchivos.push(archivo);
              
              //Hide spinner
              this.uploadingFile = false;

              //Notify result
              this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
          }, error =>
          {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);
      
              if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
              }
          }
      );
  }

  public delete(idFile : any){
      this.archivosService.delete(idFile).subscribe(
          (response)=>
          {
              //Eliminar el archivo de la lista, para que no se muestre en el formulario
              let archivos = this.listArchivos;
              archivos.forEach(function(archivo, index) {
                if(archivo.id === idFile){
                  archivos.splice(index, 1);
                }
              });

              this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');

          }, error =>
          {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          }
      );
  }

  public downloadFile(idFile : any) {
      this.archivosService.getFile(idFile).subscribe(
        (response)=>
        {
          const fileUrl = window.URL.createObjectURL(response.blob());
          //Muestra el archivo en una nueva ventana
          window.open(fileUrl);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
  }

  public updateArchivos(){
      this.archivosService.update(this.listArchivos).subscribe(
        (response)=>
        {
          const archivos = response.json().content;
          this.helperService.notification('Archivos actualizados', 'Se ha actualizado la información de los archivos ', 'success');
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/adjuntar-archivos/adjuntar-archivos.component.ts